import {NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA} from "@angular/core";
import {FormfieldComponent} from "./formfield/formfield.component";
import {CommonModule} from "@angular/common";
import {MatTooltipModule} from "@angular/material/tooltip";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatSliderModule} from "@angular/material/slider";
import {JoyrideModule} from "ngx-joyride";
import {FormfieldInfoComponent} from "./formfield/formfield.info.component";
import {MatRadioModule} from "@angular/material/radio";
import {FormfieldInfoCalloutComponent} from "./formfield/formfield.info.callout.component";
import {BuildingConditionComponent} from "./smarthec/auswerten/building-condition/building-condition.component";
import {InfotextComponent} from "./dialog/infotext/infotext.component";
import {AppTranslatePipe} from "./pipe/AppTranslatePipe";
import {MatDialogModule} from "@angular/material/dialog";
import {DebugComponent} from "./debug/debug.component";
import {DonateComponent} from "./donate/donate.component";
import {DialogformComponent} from "./dialogform/dialogform.component";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {StepChapterComponent} from "./step/step.chapter.component";
import {StepNavigationComponent} from "./step/step.navigation.component";
import {StepButtonsComponent} from "./step/step.buttons.component";
import {RouterModule} from "@angular/router";
import {ReplacePipe} from "./pipe/ReplacePipe";
import {StepComponent} from "./step/step.component";
import {HintComponent} from "./dialog/hint/hint.component";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {AdvisorPagenotfoundComponent} from "./advisor.pagenotfound.component";
import {FooterPartnerComponent} from "./footer/partner/footer-partner.component";
import {FormfieldPresetmarkComponent} from "./formfield/formfield.presetmark.component";
import {CanvasImageComponent} from "./canvas-image/canvas-image.component";
import {DownloadComponent} from "./download/download.component";
import {TeaserComponent} from "./teaser/teaser.component";
import {PortalTeaserComponent} from "./teaser/portal.teaser.component";
import {AdvisorTeaserComponent} from "./teaser/advisor.teaser.component";
import {StepNavigationExtraComponent} from "./step/step.navigation.extra.component";
import {SafeUrlPipe} from './pipe/SafeUrlPipe';
import {AdvisorImageComponent} from "./advisor.image.component";
import {AdvisorImageUrlPipe} from "./pipe/AdvisorImagePipe";
import {AdvisorErrorpageComponent} from "./advisor.errorpage.component";
import {FormfieldRoofpitchComponent} from "./formfield/formfield.roofpitch.component";
import {FormfieldDirectionComponent} from "./formfield/formfield.direction.component";
import {TranslateModule} from "@ngx-translate/core";

const disableAnimations =
  !('animate' in document.documentElement)
  || (navigator && /iPhone OS (8|9|10|11|12|13)_/.test(navigator.userAgent));

/**
 * Shared module between the advisors that uses the FormfieldComponent. Must bei included in all modules that needs it.
 */
@NgModule({
    declarations: [FormfieldComponent, FormfieldInfoComponent, FormfieldInfoCalloutComponent, CanvasImageComponent, FormfieldPresetmarkComponent, BuildingConditionComponent,
      InfotextComponent, AppTranslatePipe, DebugComponent, DonateComponent, DialogformComponent, StepButtonsComponent, StepComponent, StepChapterComponent, AdvisorTeaserComponent,
      StepNavigationComponent, ReplacePipe, HintComponent, AdvisorPagenotfoundComponent, FooterPartnerComponent, DownloadComponent, TeaserComponent,
      PortalTeaserComponent, StepNavigationExtraComponent, AdvisorImageComponent,
      SafeUrlPipe, AdvisorImageUrlPipe, AdvisorErrorpageComponent, FormfieldRoofpitchComponent, FormfieldDirectionComponent
    ],
  imports: [
    CommonModule,
    MatTooltipModule,
    FormsModule,
    BrowserAnimationsModule.withConfig({disableAnimations}),
    ReactiveFormsModule,
    MatSliderModule,
    JoyrideModule.forRoot(),
    RouterModule,
    MatRadioModule,
    MatDialogModule,
    MatCheckboxModule,
    TranslateModule
  ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
    exports: [
        CommonModule,
        FormfieldComponent,
        BuildingConditionComponent,
        InfotextComponent,
        AppTranslatePipe,
        MatRadioModule,
        MatDialogModule,
        DebugComponent,
        DonateComponent,
        DialogformComponent,
        StepComponent,
        StepChapterComponent,
        StepNavigationComponent,
        StepButtonsComponent,
        ReplacePipe,
        HintComponent,
        AdvisorPagenotfoundComponent,
        FooterPartnerComponent,
        DownloadComponent,
        TeaserComponent,
        PortalTeaserComponent,
        AdvisorTeaserComponent,
        StepNavigationExtraComponent,
        MatCheckboxModule,
        AdvisorImageComponent,
        SafeUrlPipe,
        AdvisorImageUrlPipe,
        AdvisorErrorpageComponent
    ],
})
export class AdvisorSharedModule {
}
